import * as data from "data";
import * as search from "courses/coursesearch";

data.getData("courses").then(function () {
    search.init();
})


//////////////////
// WEBPACK FOOTER
// ./src/js/courses/courses.js
// module id = 474
// module chunks = 1